















































import { Component, Watch } from 'vue-property-decorator';

import { treatValue } from '@/utils/moneyTreatments';
import {
  CustomSelectModel,
  CustomSelectGroup,
  CustomSelectOption
} from '@/components/CustomSelect/CustomSelectModel';
import Card from '@/components/Card/Card.vue';
import CustomSelect from '@/components/CustomSelect/CustomSelect.vue';
import DateUtils from '@/utils/DateUtils';
import BusinessService from '@/api/BusinessService';
import BasePaginaion from '@/components/BasePagination/BasePagination.vue';
import PaginationHelper from '@/utils/PaginationHelper';
import { openCenterModal } from '@/utils/modal';
import ShareBanner from '@/components/ShareBanner/ShareBanner.vue';
import DashboardProgress from '@/components/DashboardProgress/DashboardProgress.vue';
import Page from '@/componentsV2/molecules/Page/Page.vue';

type Row = {
  message: string;
  createdAt: string;
};

@Component({
  components: {
    Card,
    CustomSelect,
    ShareBanner,
    DashboardProgress,
    Page
  }
})
export default class Dashboard extends BasePaginaion {
  constructor() {
    super();
  }

  filterData: any = {
    limit: 10,
    next: '' //TODO
  };
  treatValue = treatValue;
  selectedTab = 'all-transactions';
  headerFixed = false;
  businessService: BusinessService = new BusinessService();
  rows: Row[] = [];
  headerWidth = '100%';
  isLoading = true;
  helper: PaginationHelper = new PaginationHelper();
  header: object[] = [];
  lastPeriod = 'allTime';
  targetClassForInfineScroll = '.container-scrollable';

  mounted() {
    this.assignHeader();

    if (this.$store.state.stripe.connection === 'success') {
      this.$notification('Account successfully linked with Stripe.', 'success');
    }

    if (this.$route.params.isInvite) {
      const { data, invite } = this.$route.params;
      openCenterModal('inviteModal', {
        data,
        invite
      });
    }
  }

  get isNotHidden() {
    const { business } = this.$store.getters['business/getBusinessInfo'];
    return business && business.status !== 'hidden';
  }

  assignHeader() {
    let _header: object[] = [];

    _header.push(
      {
        label: 'All Transactions',
        isSelected: true,
        id: 'all-transactions'
      },
      {
        label: 'Card Transactions',
        isSelected: false,
        id: 'credit-card-transactions'
      },
      {
        label: 'Coin Transactions',
        isSelected: false,
        id: 'coins-transactions'
      }
    );

    this.header = _header;
  }

  periodChanged(data: any) {
    const { uuid } = data[0];
    if (uuid === this.lastPeriod) return;
    this.lastPeriod = data[0].uuid;

    if (data[0].uuid == 'allTime') delete this.filterData.extras;
    else this.filterData.extras = `time:${data[0].uuid}`;

    this.reloadList(true);
  }

  initFilterModel() {
    const actionGroup = new CustomSelectGroup([
      new CustomSelectOption('allTime', 'All time', true),
      new CustomSelectOption('sevenDays', '7 days'),
      new CustomSelectOption('oneMonth', '1 month'),
      new CustomSelectOption('threeMonths', '3 month')
    ]);

    this.filterModel = new CustomSelectModel(
      [actionGroup],
      `By period`,
      false,
      false,
      false,
      true
    );
  }

  getDate(date: string) {
    const utils: any = new DateUtils();
    return utils.constructor.formatISODate(date);
  }

  reloadList(clearList: boolean) {
    if (clearList) {
      this.maxItems = false;
      this.filterData.next = '';
    }

    if (this.maxItems) return;
    this.typeListChange(this.selectedTab, clearList);
  }

  typeListChange(tabId: string, clearList: boolean) {
    if (clearList) {
      this.maxItems = false;
      this.filterData.next = '';
    }

    this.selectedTab = tabId;
    this.header.map((item: any) => {
      item.isSelected = item.id === tabId;
    });

    if (!tabId) return;

    this.getTransactions(tabId, clearList);
  }

  async getTransactions(type?: string, clearList = false) {
    this.$showLoaderWithLocker();

    try {
      const response = await this.businessService.getTransactionsByType(
        this.filterData,
        this.filterData.next,
        type
      );

      if (!clearList) {
        this.rows = [
          ...this.rows,
          ...this.getTransactionRow(response.data.items)
        ];
      } else {
        this.rows = this.getTransactionRow(response.data.items);
      }

      if (response.data.links.next) {
        this.maxItems = false;
        this.filterData.next = response.data.links.next;
      } else {
        this.maxItems = true;
      }
    } finally {
      this.$hideLoader();
      this.isLoading = false;
    }
  }

  getTransactionRow(items: Row[]) {
    return items
      .map(({ message, createdAt }) => ({ message, createdAt }))
      .filter(({ message }) => message);
  }
}
